import { Modal, Result } from "antd";
import React, { useState } from "react";

function AddPositionUserModal(props) {
  const [submit, setSubmit] = useState(false);

  function handleCancel() {
    props.handleCancel();
  }

  return (
    <Modal
      title="Add user"
      visible={props.visible}
      onOk={props.handleOk}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Result status="404" title="Coming soon" />
    </Modal>
  );
}

export default AddPositionUserModal;
